export function hasPermission(scope: readonly string[], path: string): boolean {
  if (path === '') return true
  if (scope.includes('*')) return true

  const parts = path.split('.')
  for (let i = parts.length; i > 0; i--) {
    const ancestor = parts.slice(0, i).join('.')
    if (scope.includes(ancestor) || scope.includes(`${ancestor}.*`)) return true
  }

  return scope.some((held) => held.startsWith(`${path}.`))
}
